import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { timeout, map } from 'rxjs/operators';

const mainUrl = environment.url;

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(private http: HttpClient) { }

  getAllCountries(): Observable<any> {
    return this.http.get(mainUrl + 'param-country')
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getAllCountriesPaged(size: string | null, page: string | null): Observable<any> {
    let params: HttpParams
    let desc =  'id,desc'
    if (size || page) {
      params = new HttpParams({
        fromObject: {
          'size': size || null,
          'page': page || null,
          'sort': desc }
      })
    } else {
      params = new HttpParams()
    }
    return this.http.get(mainUrl + 'param-country/paged', { params: params })
  }

  createCountry(form): Observable<any> {
    return this.http.post(mainUrl + 'param-country', form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getCountryById(id): Observable<any> {
    return this.http.get(mainUrl + 'param-country/' + id)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  updateCountry(id, form): Observable<any> {
    return this.http.put(mainUrl + 'param-country/' + id, form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  deleteCountry(id): Observable<any> {
    return this.http.delete(mainUrl + 'param-country/' + id)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getAllCitiesByCountryId(id): Observable<any> {
    return this.http.get(mainUrl + `param-country/cities/${id}`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getHeader() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': window.localStorage.getItem('token')
     });

    return headers;
  }
}
